import React from 'react';

const Map = () => {
  return (
    <div >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3460.628744278924!2d74.02397427433009!3d29.846136227941514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39164dae5f40000f%3A0xa1891036f375771e!2sOOKLASS!5e0!3m2!1sen!2sin!4v1696060676392!5m2!1sen!2sin"
        width="100%"
        height="400"
        title="Google Map"
        frameBorder="0"
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      ></iframe>
    </div>
  );
};

export default Map;
